import script from "./BaseApply.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseApply.vue?vue&type=script&setup=true&lang=js"

import "./BaseApply.vue?vue&type=style&index=0&id=0bdfa273&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdfa273"]])

export default __exports__